<template>
    <div class="d-flex overflow-x-auto">
        <div v-for="item in items" :key="item.route">
            <v-list-item v-if="isAllowed($router.resolve({name: item.route}).route)" link class="router-link" :to="{name: item.route}">
                {{ item.title }}
            </v-list-item>
        </div>
    </div>
</template>

<script>
    import {auth} from '@/main';

    export default {
        name: "Navigation",
        data() {
            return {
                items: [
                    {
                        route: 'orders',
                        title: 'Zamówienia'
                    },
                    {
                        route: 'offer-joins',
                        title: 'Dołącz'
                    },
                    {
                        route: 'categories',
                        title: 'Kategorie'
                    },
                    {
                        route: 'page-contents',
                        title: 'Strony medibooking'
                    },
                    {
                        route: 'companies',
                        title: 'Firmy'
                    },
                    {
                        route: 'my-companies',
                        title: 'Moje Firmy'
                    },
                    {
                        route: 'users',
                        title: 'Użytkownicy'
                    },
                    {
                        route: 'google-indexing',
                        title: 'Google Indexing',
                    },
                    {
                        route: 'codes',
                        title: 'Kody promocyjne',
                    },
                    {
                        route: 'notifications',
                        title: 'Powiadomienia',
                    },
                    {
                        route: 'price-list-companies',
                        title: 'Moduł cennikowy',
                    },
                    {
                        route: 'redirects',
                        title: 'Przekierowania',
                    },
                    {
                      route: 'price-list-contents',
                      title: 'Cenniki'
                    },
                ]
            }
        },
        methods: {
            isAllowed(route) {
                return auth.isAllowed(route);
            }
        },
    }
</script>

<style scoped>
    .v-list-item--active {
        color: #ffffff;
        border-bottom: 2px #ffffff solid;
        background-color: #607d8b;
    }

    .theme--dark.v-list-item--active::before {
        opacity: 0;
    }
</style>